import { defineStore } from 'pinia'

export const useStore = defineStore('', {
  state: () => ({
    ready: false,
  }),
})
